import React from 'react'
import { UserMenuPropsType } from './HeaderTypes'
import { DashboardIcon, DiagramIcon, LogOutIcon, MobileIcon, ResetPasswordIcon, UserIcon } from '../iconSet/IconSet'
import { API_LOGOUT_URL, APILogoutTypes } from '../../services/APIAuthorizationService'
import { APICall } from '../../services/APIService'
import { useNavigate } from 'react-router-dom'
import { useUserData } from '../../context/UserDataContext'

const UserMenu = (props: UserMenuPropsType) => {

  const navigate = useNavigate()
  const BASE_URL = process.env.REACT_APP_BASE_URL

    const { firstName } = useUserData()

    // Handle logout
    const handleLogOutButton = async () => {
        const token = localStorage.getItem("access_token");
        const refreshToken = localStorage.getItem("refresh_token");
    
        if (!refreshToken) {
          // No refresh token, just go to login page
          window.location.href = "/login"; // your React login page
          return;
        }
      
        try {
          const URL = `${BASE_URL}/identity_manager/api/v1/logout`
          // POST to Keycloak logout endpoint
          await fetch(URL, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ refresh_token: refreshToken }),
          });
        } catch (error) {
          console.error("Silent logout error:", error);
          // Even if error, we move on
        } finally {
          // Always go to login page after logout
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = "/login"; // your React login page
        }
      };

      const handleChangePassword = () =>{
        navigate('/back_office_system/change_password')
      }

    return (
        <div className={`user-icon-menu`}>
            <div className={`title`}>
                <div className='left-side'>
                  <DiagramIcon width='1.2rem' color='var(--color-text)' />
                  <span>back office system</span>
                </div>

                <div className='right-side'>
                  
                  <span>{firstName}</span>
                  {/* <UserIcon width='1.2rem' color='var(--color-text)'/> */}
                </div>
                
            </div>
            <div className={`menu-container`}>
                <div className={`item-container`} onClick={() => navigate('/edit/edit_profile')}>
                    <UserIcon width='1rem' color='var(--color-text)'/>
                    <span>my profile</span>
                </div>
                <div className={`item-container`} onClick={() => navigate('/')}>
                    <DashboardIcon width='1rem' color='var(--color-text)'/>
                    <span>dashboard</span>
                </div>
                <div className={`item-container`} onClick={() => handleLogOutButton()}>
                    <LogOutIcon width='1rem' color='var(--color-text)'/>
                    <span>log out</span>
                </div>
                <div className={`item-container`} onClick={() => handleChangePassword()}>
                    <ResetPasswordIcon width='1rem' color='var(--color-text)'/>
                    <span>change password</span>
                </div>
            </div>
        </div>
    )
}

export default UserMenu